import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";

const UserDetail = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // State for error handling
  const [blogs, setBlogs] = useState([]); // State for blogs
  const [expandedDescriptions, setExpandedDescriptions] = useState({}); // State for tracking expanded descriptions

  useEffect(() => {
    console.log("Fetching user with ID:", id);

    if (!id) {
      console.error("Error: User ID is missing.");
      setError("User  ID is missing.");
      setLoading(false);
      return;
    }

    // Fetch user data
    axios
      .get(`http://localhost:5000/api/users/${id}`)
      .then((response) => {
        setUser(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching user:", error);
        setError("Error fetching user data. Please try again later.");
        setLoading(false);
      });

    // Fetch blogs data
    axios
      .get(`http://localhost:5000/api/blogs`)
      .then((response) => {
        setBlogs(response.data);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
        setError("Error fetching blogs data. Please try again later.");
      });
  }, [id]);

  // Add effect to handle clicks outside
  useEffect(() => {
    const handleClickOutside = () => {
      if (Object.keys(expandedDescriptions).length > 0) {
        setExpandedDescriptions({});
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [expandedDescriptions]);

  if (loading) return <Loader />;
  if (error) return <p>{error}</p>; // Display error message
  if (!user) return <p>User not found.</p>;

  // Filter blogs by author name
  const userFullName = `${user.firstName} ${user.lastName}`;
  const userBlogs = blogs.filter((blog) => blog.author === userFullName);

  return (
    <div lang="en">
      <div className="container">
        <style>
          {`
            body {
              background-color: white;
              color: #1a202c;
              font-family: Arial, sans-serif;
              font-size: 16px;
            }
            .container {
              max-width: 1400px;
              margin: 0 auto;
              padding: 32px;
            }
            .flex-row {
              display: flex;
            }
            .user-section {
              flex: 1;
              padding: 16px;
            }
            .articles-section {
              flex: 3;
              padding: 16px;
              margin-left: 20px;
            }
            .article-card {
              padding: 16px;
              border: 1px solid #e2e8f0;
              border-radius: 8px;
              display: flex;
              flex-direction: column;
              margin-bottom: 24px;
            }
            .user-img {
              border-radius: 50%;
              margin-bottom: 16px;
            }
            .user-name {
              font-size: 24px;
              font-weight: bold;
            }
            .user-title {
              color: #718096;
            }
            .section-title {
              font-size: 20px;
              font-weight: bold;
              margin-top: 24px;
            }
            .section-content {
              margin-top: 8px;
              color: #4a5568;
              text-align: justify;
              line-height: 1.6;
            }
            .article-description {
              margin-top: 8px;
              color: #4a5568;
              text-align: justify;
              line-height: 1.6;
            }
            .article-title {
              font-size: 18px;
              font-weight: 600;
            }
            .article-meta {
              color: #a0aec0;
            }
            .article-thumbnail {
              border-radius: 8px;
              margin-top: 16px;
            }
            .read-more {
              color: #4299e1;
              text-decoration: none;
              margin-top: 16px;
            }
            .read-more:hover {
              text-decoration: underline;
            }
          `}
        </style>
        <div className="flex-row">
          {/* User Information Section */}
          <div className="user-section">
            <div 
              style={{
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '20px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                backgroundColor: '#f8f9fa',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <img
                alt={`Profile picture of ${user.firstName} ${user.lastName}`}
                className="user-img"
                height="120"
                width="120"
                src={user.img || "/img/307.jpg"} // Ensure correct field name for image
                style={{
                  borderRadius: '50%',
                  marginBottom: '16px',
                  objectFit: 'cover',
                  border: '3px solid white',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}
              />
              <h1 className="user-name">
                {user.firstName} {user.lastName}
              </h1>
              <p className="user-title">Email: {user.email}</p>
              
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  flexDirection: "column"
                }}
              >
              <hr style={{ margin: "10px 0", border: "50",borderTop: "1px solid rgb(0, 0, 0)", }}/>
                <div style={{ width: "100%" }}>
                  <div className="section-title">Member Since</div>
                  <p className="section-content">
                    {new Date(user.joinedDate).toDateString()}
                  </p>
                </div>
                
                <div style={{ width: "100%" }}>
                  <div className="section-title">Address</div>
                  <p className="section-content">
                    {user.address || "No address available"}
                  </p>
                </div>
                
                <hr style={{ margin: "10px 0", border: "50",borderTop: "1px solid rgb(8, 8, 8)", }}/>
              </div>

              <div className="section-title" style={{ alignSelf: 'flex-start', width: '100%' }}>About</div>
              <p className="section-content" style={{ width: '100%' }}>
                {user.aboutMe ? (
                  user.aboutMe.split(" ").length > 50 ? (
                    <>
                      {user.aboutMe.split(" ").slice(0, 50).join(" ")}...
                      <span
                        style={{
                          color: "#4299e1",
                          cursor: "pointer",
                          marginLeft: "5px",
                        }}
                        onClick={() => alert(user.aboutMe)}
                      >
                        Read more
                      </span>
                    </>
                  ) : (
                    user.aboutMe
                  )
                ) : (
                  "No bio available."
                )}
              </p>
            </div>
          </div>
          {/* Articles Section */}
          <div className="articles-section">
            <h2 className="section-title">Recent Articles</h2>
            {userBlogs.length > 0 ? (
              userBlogs.map((article) => (
                <div
                  className="article-card"
                  key={article.id}
                  style={{ flexDirection: "row", alignItems: "center" }}
                >
                  <div style={{ flex: "1" }}>
                    <h3 className="article-title">{article.title}</h3>
                    <p className="article-meta">
                      Published on{" "}
                      {new Date(article.publishedDate).toDateString()} ·{" "}
                      {article.readTime} min read
                    </p>
                    <hr
                      style={{
                        margin: "20px 0",
                        border: "50",
                        borderTop: "1px solid rgb(8, 8, 8)",
                      }}
                    />
                    <p className="article-description">
                      {article.shortDescription ? 
                        article.shortDescription.split(" ").length > 30 && !expandedDescriptions[article.id] ? 
                          <>
                            {article.shortDescription.split(" ").slice(0, 30).join(" ")}...
                            <span
                              style={{
                                color: "#4299e1",
                                cursor: "pointer",
                                marginLeft: "5px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandedDescriptions({
                                  ...expandedDescriptions,
                                  [article.id]: true
                                });
                              }}
                            >
                              Read more
                            </span>
                          </> 
                          : article.shortDescription 
                        : "No description available."}
                    </p>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <Link className="read-more" to={`/blogs/${article.id}`}>
                        Post <i className="fas fa-external-link-alt"></i>
                      </Link>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        width: "1px",
                        height: "150px",
                        backgroundColor: "#e2e8f0",
                        margin: "0 15px",
                      }}
                    ></div>
                    <div style={{ marginLeft: "10px" }}>
                      <img
                        alt={`Thumbnail for ${article.title}`}
                        className="article-thumbnail"
                        height="120"
                        width="120"
                        src={
                          article.image || "/img/cart-img/cart-item-01.jpg"
                        }
                        style={{
                          objectFit: "cover",
                          borderRadius: "8px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No articles found for this user.</p>
            )}
          </div>
        </div>
      </div>
     
    </div>
  );
};

export default UserDetail;